var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mostrarComponente()
    ? _c(
        "b-container",
        { class: { "font-weight-bold": _vm.boldFields }, attrs: { fluid: "" } },
        [
          _vm.mostrarAlertaSemaforo
            ? _c("div", { staticClass: "alerta-semaforo-derecha" }, [
                _c(
                  "button",
                  {
                    staticClass: "cerrar-alerta-semaforo",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.mostrarAlertaSemaforo = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("strong", [_vm._v("Validación requerida")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n      " + _vm._s(_vm.mensajeAlertaSemaforo) + "\n    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          variant: "primary",
                          size: "sm",
                          id: "toggle-bold-link",
                        },
                        on: {
                          click: function ($event) {
                            _vm.boldFields = !_vm.boldFields
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.boldFields
                                ? "Texto normal"
                                : "Texto en negritas"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-tooltip", { attrs: { target: "toggle-bold-link" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.boldFields
                              ? "Deshabilitar texto en negritas"
                              : "Habilitar texto en negritas"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("bandeja.estimación")),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-badge",
                    {
                      attrs: {
                        variant: "primary",
                        href: _vm.solicitud.SOLICITUD_RIZOMA.documentoPu
                          .documento.uri,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("bandeja.verPu")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-badge",
                    {
                      attrs: {
                        variant: "primary",
                        href: _vm.solicitud.SOLICITUD_RIZOMA.documentoSolicitud
                          .documento.uri,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("bandeja.verSolicitud")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.solicitud.reconsideracion &&
                  _vm.solicitud.reconsideracion.uri
                    ? _c(
                        "b-badge",
                        {
                          attrs: {
                            variant: "primary",
                            href: _vm.solicitud.reconsideracion.uri,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("bandeja.verReconsideracion")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-3", attrs: { md: "12" } },
                        [
                          _c("div", { staticClass: "alerta-evaluacion-2026" }, [
                            _c(
                              "div",
                              { staticClass: "icono-alerta-evaluacion" },
                              [_vm._v("i")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "texto-alerta-evaluacion" },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                La rúbrica de evaluación se compone de la valoración cuantitativa (serie de actividades para cada uno de los componentes)\n                y la valoración cualitativa, donde usted realizará la selección de una opción en la escala de valoración de las cualidades\n                definidas por componente.\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _vm.segundaOportunidadActiva
                            ? _c(
                                "b-alert",
                                {
                                  staticClass:
                                    "aviso-segunda-oportunidad-tabla",
                                  attrs: { show: "", variant: "warning" },
                                },
                                [
                                  _vm._v(
                                    "\n            Tiene una segunda oportunidad adicional para evaluar.\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "tablaValoracionCualitativa",
                              staticClass: "contenedor-tabla-valoracion",
                              class: {
                                "resaltar-segunda-oportunidad":
                                  _vm.resaltarTablaSegundaOportunidad,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tabla-evaluacion-2026",
                                  class: {
                                    "evaluacion-bloqueada":
                                      _vm.evaluacionBloqueada,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "bloque-componente" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "titulo-componente" },
                                        [
                                          _vm._v("Componente "),
                                          _c("strong", [
                                            _vm._v(
                                              "1. Producción científica, humanística o tecnológica"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "encabezado-componente",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "columna-actividades-header",
                                            },
                                            [_vm._v("Actividades")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "columna-cualidades-header",
                                            },
                                            [_vm._v("Cualidades")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "contenido-componente" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "columna-actividades",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(" Artículos "),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalArticulos)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(" Libros "),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalLibros)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(" Capítulos "),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalCapitulos)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Reportes"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalReportes)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Informes"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalInformes)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Dossier o número temático"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalDossier)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Antologías"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalAntologias
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Traducciones de obras"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalTraducciones
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Prólogos y estudios introductorios"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalPrologoEstudioIntroductorio
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Datos primarios"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalBaseDatosPrimarios
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Curaduría"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.totalCuraduria)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " Desarrollo tecnológico o innovación "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalDesarrolloTecnologicoInnovacion
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " Propiedad intelectual "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalPropiedadintelectual
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "fila-actividad",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Transferencias tecnológicas"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalTransferenciatecno
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "fila-actividad fila-total",
                                                },
                                                [
                                                  _c("span", [_vm._v("Total")]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        Number(
                                                          _vm.totalArticulos ||
                                                            0
                                                        ) +
                                                          Number(
                                                            _vm.totalLibros || 0
                                                          ) +
                                                          Number(
                                                            _vm.totalCapitulos ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalInformes ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalReportes ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalDossier ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalAntologias ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalTraducciones ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalPrologoEstudioIntroductorio ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalBaseDatosPrimarios ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalCuraduria ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalDesarrolloTecnologicoInnovacion ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalPropiedadintelectual ||
                                                              0
                                                          ) +
                                                          Number(
                                                            _vm.totalTransferenciatecno ||
                                                              0
                                                          )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "columna-cualidades",
                                              class: {
                                                "disabled-section":
                                                  _vm.deshabilitarSecciones,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bloque-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "texto-cualidad",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Relevante"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                          Cuando es una contribución original que aporta al avance de la investigación científica, humanística o\n                          tecnológica.\n                        "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "escala-cualidad",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .relevante ===
                                                              "Muy baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .relevante,
                                                                expression:
                                                                  "valoracionesCualitativasEme.relevante",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "relevante",
                                                              value: "Muy baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .relevante,
                                                                "Muy baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "relevante",
                                                                  "Muy baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .relevante ===
                                                              "Baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .relevante,
                                                                expression:
                                                                  "valoracionesCualitativasEme.relevante",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "relevante",
                                                              value: "Baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .relevante,
                                                                "Baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "relevante",
                                                                  "Baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo moderada",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .relevante ===
                                                              "Moderada",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .relevante,
                                                                expression:
                                                                  "valoracionesCualitativasEme.relevante",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "relevante",
                                                              value: "Moderada",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .relevante,
                                                                "Moderada"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "relevante",
                                                                  "Moderada"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Moderada"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .relevante ===
                                                              "Alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .relevante,
                                                                expression:
                                                                  "valoracionesCualitativasEme.relevante",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "relevante",
                                                              value: "Alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .relevante,
                                                                "Alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "relevante",
                                                                  "Alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .relevante ===
                                                              "Muy alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .relevante,
                                                                expression:
                                                                  "valoracionesCualitativasEme.relevante",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "relevante",
                                                              value: "Muy alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .relevante,
                                                                "Muy alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "relevante",
                                                                  "Muy alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bloque-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "texto-cualidad",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Pertinente"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                          Cuando la producción está vinculada con necesidades sociales, ambientales o tecnológicas, o bien, amplía las\n                          fronteras del conocimiento en un área específica.\n                        "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "escala-cualidad",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .pertinente ===
                                                              "Muy baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .pertinente,
                                                                expression:
                                                                  "valoracionesCualitativasEme.pertinente",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "pertinente",
                                                              value: "Muy baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .pertinente,
                                                                "Muy baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "pertinente",
                                                                  "Muy baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .pertinente ===
                                                              "Baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .pertinente,
                                                                expression:
                                                                  "valoracionesCualitativasEme.pertinente",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "pertinente",
                                                              value: "Baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .pertinente,
                                                                "Baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "pertinente",
                                                                  "Baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo moderada",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .pertinente ===
                                                              "Moderada",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .pertinente,
                                                                expression:
                                                                  "valoracionesCualitativasEme.pertinente",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "pertinente",
                                                              value: "Moderada",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .pertinente,
                                                                "Moderada"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "pertinente",
                                                                  "Moderada"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Moderada"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .pertinente ===
                                                              "Alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .pertinente,
                                                                expression:
                                                                  "valoracionesCualitativasEme.pertinente",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "pertinente",
                                                              value: "Alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .pertinente,
                                                                "Alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "pertinente",
                                                                  "Alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .pertinente ===
                                                              "Muy alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .pertinente,
                                                                expression:
                                                                  "valoracionesCualitativasEme.pertinente",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "pertinente",
                                                              value: "Muy alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .pertinente,
                                                                "Muy alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "pertinente",
                                                                  "Muy alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bloque-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "texto-cualidad",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Sostenida"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                          Cuando la producción que realiza a lo largo del tiempo muestra consolidación en las líneas de investigación y,\n                          eventualmente, se desarrollan nuevas líneas de investigación como parte de la trayectoria.\n                        "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "escala-cualidad",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .sostenida ===
                                                              "Muy baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .sostenida,
                                                                expression:
                                                                  "valoracionesCualitativasEme.sostenida",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "sostenida",
                                                              value: "Muy baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .sostenida,
                                                                "Muy baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "sostenida",
                                                                  "Muy baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .sostenida ===
                                                              "Baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .sostenida,
                                                                expression:
                                                                  "valoracionesCualitativasEme.sostenida",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "sostenida",
                                                              value: "Baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .sostenida,
                                                                "Baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "sostenida",
                                                                  "Baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo moderada",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .sostenida ===
                                                              "Moderada",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .sostenida,
                                                                expression:
                                                                  "valoracionesCualitativasEme.sostenida",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "sostenida",
                                                              value: "Moderada",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .sostenida,
                                                                "Moderada"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "sostenida",
                                                                  "Moderada"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Moderada"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .sostenida ===
                                                              "Alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .sostenida,
                                                                expression:
                                                                  "valoracionesCualitativasEme.sostenida",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "sostenida",
                                                              value: "Alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .sostenida,
                                                                "Alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "sostenida",
                                                                  "Alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .sostenida ===
                                                              "Muy alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .sostenida,
                                                                expression:
                                                                  "valoracionesCualitativasEme.sostenida",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "sostenida",
                                                              value: "Muy alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .sostenida,
                                                                "Muy alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "sostenida",
                                                                  "Muy alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bloque-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "texto-cualidad",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Diversa"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                          Cuando la persona investigadora tiene la capacidad de difundir sus conocimientos mediante diferentes tipos de\n                          productos.\n                        "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "escala-cualidad",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .diversa ===
                                                              "Muy baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .diversa,
                                                                expression:
                                                                  "valoracionesCualitativasEme.diversa",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "diversa",
                                                              value: "Muy baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .diversa,
                                                                "Muy baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "diversa",
                                                                  "Muy baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo baja",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .diversa ===
                                                              "Baja",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .diversa,
                                                                expression:
                                                                  "valoracionesCualitativasEme.diversa",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "diversa",
                                                              value: "Baja",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .diversa,
                                                                "Baja"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "diversa",
                                                                  "Baja"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Baja"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo moderada",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .diversa ===
                                                              "Moderada",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .diversa,
                                                                expression:
                                                                  "valoracionesCualitativasEme.diversa",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "diversa",
                                                              value: "Moderada",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .diversa,
                                                                "Moderada"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "diversa",
                                                                  "Moderada"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Moderada"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .diversa ===
                                                              "Alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .diversa,
                                                                expression:
                                                                  "valoracionesCualitativasEme.diversa",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "diversa",
                                                              value: "Alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .diversa,
                                                                "Alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "diversa",
                                                                  "Alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "opcion-semaforo muy-alta",
                                                          class: {
                                                            seleccionada:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .diversa ===
                                                              "Muy alta",
                                                          },
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .valoracionesCualitativasEme
                                                                    .diversa,
                                                                expression:
                                                                  "valoracionesCualitativasEme.diversa",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "diversa",
                                                              value: "Muy alta",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .valoracionesCualitativasEme
                                                                  .diversa,
                                                                "Muy alta"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.valoracionesCualitativasEme,
                                                                  "diversa",
                                                                  "Muy alta"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v("Muy alta"),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "bloque-componente componente-2",
                                  class: {
                                    "evaluacion-bloqueada":
                                      _vm.evaluacionBloqueada,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "titulo-componente" },
                                    [
                                      _vm._v("Componente "),
                                      _c("strong", [
                                        _vm._v(
                                          "2. Fortalecimiento y consolidación de la comunidad"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "encabezado-componente" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-actividades-header",
                                        },
                                        [_vm._v("Actividades")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-cualidades-header",
                                        },
                                        [_vm._v("Cualidades")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "contenido-componente" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "columna-actividades" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(" Docencia "),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.totalDocencia)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Desarrollo institucional"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalDesarrolloInstitucional
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " Trabajos de titulación "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totaltrabajosTitulacion
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v("Evaluación de pares"),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.totalOtros)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v("Trabajo editorial"),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalParticipacionEditorial
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fila-actividad fila-total",
                                            },
                                            [
                                              _c("span", [_vm._v(" Total ")]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      Number(
                                                        _vm.totalDocencia || 0
                                                      ) +
                                                        Number(
                                                          _vm.totalDesarrolloInstitucional ||
                                                            0
                                                        ) +
                                                        Number(
                                                          _vm.totaltrabajosTitulacion ||
                                                            0
                                                        ) +
                                                        Number(
                                                          _vm.totalOtros || 0
                                                        ) +
                                                        Number(
                                                          _vm.totalParticipacionEditorial ||
                                                            0
                                                        )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-cualidades cualidades-componente-2",
                                          class: {
                                            "disabled-section":
                                              _vm.deshabilitarSecciones,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "bloque-cualidad" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "texto-cualidad",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Comprometido con la formación"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                        Cuando se desarrollan actividades de docencia o acompañamiento en la obtención de grado o en la tutoría de\n                        estancias y proyectos de investigación de estudiantes de nivel medio superior, licenciatura, maestría, doctorado o\n                        aquellas vinculadas con estancias posdoctorales.\n                      "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "escala-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprometidoFormacion ===
                                                          "Muy baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprometidoFormacion,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprometidoFormacion",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprometidoFormacion",
                                                          value: "Muy baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprometidoFormacion,
                                                            "Muy baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprometidoFormacion",
                                                              "Muy baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprometidoFormacion ===
                                                          "Baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprometidoFormacion,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprometidoFormacion",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprometidoFormacion",
                                                          value: "Baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprometidoFormacion,
                                                            "Baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprometidoFormacion",
                                                              "Baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo moderada",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprometidoFormacion ===
                                                          "Moderada",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprometidoFormacion,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprometidoFormacion",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprometidoFormacion",
                                                          value: "Moderada",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprometidoFormacion,
                                                            "Moderada"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprometidoFormacion",
                                                              "Moderada"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Moderada"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprometidoFormacion ===
                                                          "Alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprometidoFormacion,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprometidoFormacion",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprometidoFormacion",
                                                          value: "Alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprometidoFormacion,
                                                            "Alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprometidoFormacion",
                                                              "Alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprometidoFormacion ===
                                                          "Muy alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprometidoFormacion,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprometidoFormacion",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprometidoFormacion",
                                                          value: "Muy alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprometidoFormacion,
                                                            "Muy alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprometidoFormacion",
                                                              "Muy alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "bloque-cualidad" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "texto-cualidad",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Colaborativo"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                        Cuando se implementan acciones que fomenten la vinculación entre estudiantes (vocaciones científicas) y personas\n                        investigadoras.\n                      "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "escala-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .colaborativo ===
                                                          "Muy baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .colaborativo,
                                                            expression:
                                                              "valoracionesCualitativasEme.colaborativo",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "colaborativo",
                                                          value: "Muy baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .colaborativo,
                                                            "Muy baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "colaborativo",
                                                              "Muy baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .colaborativo ===
                                                          "Baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .colaborativo,
                                                            expression:
                                                              "valoracionesCualitativasEme.colaborativo",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "colaborativo",
                                                          value: "Baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .colaborativo,
                                                            "Baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "colaborativo",
                                                              "Baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo moderada",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .colaborativo ===
                                                          "Moderada",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .colaborativo,
                                                            expression:
                                                              "valoracionesCualitativasEme.colaborativo",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "colaborativo",
                                                          value: "Moderada",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .colaborativo,
                                                            "Moderada"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "colaborativo",
                                                              "Moderada"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Moderada"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .colaborativo ===
                                                          "Alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .colaborativo,
                                                            expression:
                                                              "valoracionesCualitativasEme.colaborativo",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "colaborativo",
                                                          value: "Alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .colaborativo,
                                                            "Alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "colaborativo",
                                                              "Alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .colaborativo ===
                                                          "Muy alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .colaborativo,
                                                            expression:
                                                              "valoracionesCualitativasEme.colaborativo",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "colaborativo",
                                                          value: "Muy alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .colaborativo,
                                                            "Muy alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "colaborativo",
                                                              "Muy alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "bloque-cualidad" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "texto-cualidad",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Constante"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "Cuando se realizan las actividades de forma continua a lo largo de su trayectoria."
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "escala-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .constante ===
                                                          "Muy baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .constante,
                                                            expression:
                                                              "valoracionesCualitativasEme.constante",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "constante",
                                                          value: "Muy baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .constante,
                                                            "Muy baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "constante",
                                                              "Muy baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .constante ===
                                                          "Baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .constante,
                                                            expression:
                                                              "valoracionesCualitativasEme.constante",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "constante",
                                                          value: "Baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .constante,
                                                            "Baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "constante",
                                                              "Baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo moderada",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .constante ===
                                                          "Moderada",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .constante,
                                                            expression:
                                                              "valoracionesCualitativasEme.constante",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "constante",
                                                          value: "Moderada",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .constante,
                                                            "Moderada"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "constante",
                                                              "Moderada"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Moderada"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .constante ===
                                                          "Alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .constante,
                                                            expression:
                                                              "valoracionesCualitativasEme.constante",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "constante",
                                                          value: "Alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .constante,
                                                            "Alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "constante",
                                                              "Alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .constante ===
                                                          "Muy alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .constante,
                                                            expression:
                                                              "valoracionesCualitativasEme.constante",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "constante",
                                                          value: "Muy alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .constante,
                                                            "Muy alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "constante",
                                                              "Muy alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "bloque-componente componente-3",
                                  class: {
                                    "evaluacion-bloqueada":
                                      _vm.evaluacionBloqueada,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "titulo-componente" },
                                    [
                                      _vm._v("Componente "),
                                      _c("strong", [_vm._v("3. Divulgación")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "encabezado-componente" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-actividades-header",
                                        },
                                        [_vm._v("Actividades")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-cualidades-header",
                                        },
                                        [_vm._v("Cualidades")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "contenido-componente" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "columna-actividades" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Eventos y comunicación"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalEventoComunicacion
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Museografía y espacios de educación no formal"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalMuseografiaEspaciosEducacionNoFormal
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Participación en medios audiovisuales, radiofónicos o digitales"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalAudiovisualesRadiofonicosDigitales
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Medios escritos (Publicaciones de divulgación)"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalMediosEscritos
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fila-actividad" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Participación en congresos"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.totalParticipacionCongresos
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fila-actividad fila-total",
                                            },
                                            [
                                              _c("span", [_vm._v("Total")]),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    Number(
                                                      _vm.totalEventoComunicacion ||
                                                        0
                                                    ) +
                                                      Number(
                                                        _vm.totalMuseografiaEspaciosEducacionNoFormal ||
                                                          0
                                                      ) +
                                                      Number(
                                                        _vm.totalAudiovisualesRadiofonicosDigitales ||
                                                          0
                                                      ) +
                                                      Number(
                                                        _vm.totalMediosEscritos ||
                                                          0
                                                      ) +
                                                      Number(
                                                        _vm.totalParticipacionCongresos ||
                                                          0
                                                      )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columna-cualidades cualidades-componente-3",
                                          class: {
                                            "disabled-section":
                                              _vm.deshabilitarSecciones,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "bloque-cualidad" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "texto-cualidad",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Inclusiva y gratuita"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                        Cuando las actividades están dirigidas a la población tomando en cuenta su diversidad según edad, sexo, lengua,\n                        discapacidad (física, sensorial, intelectual y psicosocial) o etnia. La población podrá acceder al conocimiento\n                        sin pagar por ello.\n                      "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "escala-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .inclusivaGratuita ===
                                                          "Muy baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .inclusivaGratuita,
                                                            expression:
                                                              "valoracionesCualitativasEme.inclusivaGratuita",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "inclusivaGratuita",
                                                          value: "Muy baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .inclusivaGratuita,
                                                            "Muy baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "inclusivaGratuita",
                                                              "Muy baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .inclusivaGratuita ===
                                                          "Baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .inclusivaGratuita,
                                                            expression:
                                                              "valoracionesCualitativasEme.inclusivaGratuita",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "inclusivaGratuita",
                                                          value: "Baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .inclusivaGratuita,
                                                            "Baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "inclusivaGratuita",
                                                              "Baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo moderada",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .inclusivaGratuita ===
                                                          "Moderada",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .inclusivaGratuita,
                                                            expression:
                                                              "valoracionesCualitativasEme.inclusivaGratuita",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "inclusivaGratuita",
                                                          value: "Moderada",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .inclusivaGratuita,
                                                            "Moderada"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "inclusivaGratuita",
                                                              "Moderada"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Moderada"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .inclusivaGratuita ===
                                                          "Alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .inclusivaGratuita,
                                                            expression:
                                                              "valoracionesCualitativasEme.inclusivaGratuita",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "inclusivaGratuita",
                                                          value: "Alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .inclusivaGratuita,
                                                            "Alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "inclusivaGratuita",
                                                              "Alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .inclusivaGratuita ===
                                                          "Muy alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .inclusivaGratuita,
                                                            expression:
                                                              "valoracionesCualitativasEme.inclusivaGratuita",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "inclusivaGratuita",
                                                          value: "Muy alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .inclusivaGratuita,
                                                            "Muy alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "inclusivaGratuita",
                                                              "Muy alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "bloque-cualidad" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "texto-cualidad",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Comprensible"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                        Cuando el medio de comunicación se caracteriza por utilizar un lenguaje e imagen clara que facilite la\n                        interpretación y pueda ser asimilado de forma sencilla, que permita la reflexión y apropiación del conocimiento.\n                      "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "escala-cualidad",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprensible ===
                                                          "Muy baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprensible,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprensible",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprensible",
                                                          value: "Muy baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprensible,
                                                            "Muy baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprensible",
                                                              "Muy baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo baja",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprensible ===
                                                          "Baja",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprensible,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprensible",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprensible",
                                                          value: "Baja",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprensible,
                                                            "Baja"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprensible",
                                                              "Baja"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Baja"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo moderada",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprensible ===
                                                          "Moderada",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprensible,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprensible",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprensible",
                                                          value: "Moderada",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprensible,
                                                            "Moderada"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprensible",
                                                              "Moderada"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Moderada"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprensible ===
                                                          "Alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprensible,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprensible",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprensible",
                                                          value: "Alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprensible,
                                                            "Alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprensible",
                                                              "Alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "opcion-semaforo muy-alta",
                                                      class: {
                                                        seleccionada:
                                                          _vm
                                                            .valoracionesCualitativasEme
                                                            .comprensible ===
                                                          "Muy alta",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .valoracionesCualitativasEme
                                                                .comprensible,
                                                            expression:
                                                              "valoracionesCualitativasEme.comprensible",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          name: "comprensible",
                                                          value: "Muy alta",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm
                                                              .valoracionesCualitativasEme
                                                              .comprensible,
                                                            "Muy alta"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.valoracionesCualitativasEme,
                                                              "comprensible",
                                                              "Muy alta"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Muy alta"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "bloque-resultado-evaluacion" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "nivel-sugerido-bloque" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "titulo-nivel-sugerido",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Nivel sugerido de acuerdo a los rangos cuantitativos y a la valoración cualitativa seleccionada:\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.evaluacionEmeGuardadaFinal &&
                                              _vm.mostrarBotonConfirmar,
                                            expression:
                                              "!evaluacionEmeGuardadaFinal && mostrarBotonConfirmar",
                                          },
                                        ],
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.nivelEvaluacion1.nombre,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.nivelEvaluacion1,
                                              "nombre",
                                              $$v
                                            )
                                          },
                                          expression: "nivelEvaluacion1.nombre",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.evaluacionEmeGuardadaFinal &&
                                              _vm.segundaOportunidadActiva,
                                            expression:
                                              "!evaluacionEmeGuardadaFinal && segundaOportunidadActiva",
                                          },
                                        ],
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.nivelEvaluacion2.nombre,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.nivelEvaluacion2,
                                              "nombre",
                                              $$v
                                            )
                                          },
                                          expression: "nivelEvaluacion2.nombre",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.evaluacionEmeGuardadaFinal,
                                            expression:
                                              "evaluacionEmeGuardadaFinal",
                                          },
                                        ],
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.recomendado.nombre,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.recomendado,
                                              "nombre",
                                              $$v
                                            )
                                          },
                                          expression: "recomendado.nombre",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-alert",
                                    {
                                      attrs: {
                                        show:
                                          _vm.mostrarAlertConfirmacion ||
                                          _vm.evaluacionEmeGuardadaFinal,
                                        variant: "success",
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          " ¡La valoración cualitativa ha sido concluida satisfactoriamente! "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mostrarBotonConfirmar,
                                          expression: "mostrarBotonConfirmar",
                                        },
                                      ],
                                      staticClass: "confirmacion-nivel",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "pregunta-confirmacion",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  ¿Confirma el nivel sugerido?\n\n                  "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.right",
                                                  value: {
                                                    title:
                                                      "En caso de que el nivel sugerido no se adapte a su recomendación, podrá realizar una vez más la valoración cualitativa.",
                                                    variant: "danger",
                                                  },
                                                  expression:
                                                    "{\n                      title:\n                        'En caso de que el nivel sugerido no se adapte a su recomendación, podrá realizar una vez más la valoración cualitativa.',\n                      variant: 'danger',\n                    }",
                                                  modifiers: {
                                                    hover: true,
                                                    right: true,
                                                  },
                                                },
                                              ],
                                              staticClass: "icono-tooltip",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    i\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "botones-confirmacion" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn-confirmacion btn-confirmacion-guinda",
                                              class: {
                                                activo:
                                                  _vm.confirmaNivelSugerido ===
                                                  "SI",
                                              },
                                              attrs: {
                                                disabled:
                                                  !_vm.todasValoracionesCapturadasEmeritos,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.guardarEvaluacionSi()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Sí\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn-confirmacion btn-confirmacion-guinda",
                                              class: {
                                                activo:
                                                  _vm.confirmaNivelSugerido ===
                                                  "NO",
                                              },
                                              attrs: {
                                                disabled:
                                                  !_vm.todasValoracionesCapturadasEmeritos,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.guardarEvaluacionNo()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    No\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }